import {
  Divider,
  Icon,
  Typography,
  useMediaQuery
} from '@/modules/perseo-billing/ui/react/src';

const Header = ({ isCencoPay }: { isCencoPay?: boolean }) => {
  const isMobile = useMediaQuery('lg');

  return (
    <>
      <div className="co-flex co-items-center co-justify-between">
        <Typography
          size="h2"
          weight="semibold"
          className="co-text-pds-neutral-900"
          tabIndex={0}
        >
          Medio de pago
        </Typography>
        {isCencoPay && (
          <Icon width={isMobile ? 120 : 178} height={30} icon="CencoPayLogo" />
        )}
      </div>
      <Divider />
    </>
  );
};

export default Header;
